export enum AddressType {
        DefaultAddress,
        BillingAddress1,
        BillingAddress2,
        ShippingAddress1,
        ShippingAddress2,
        AutomaticTopUpAddress,
        TopUpAddress,
}
